import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isExchangeFlowSet } from '../../../../actionCreators/myAccount';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
import LinkProvider from '../../../../CommonComponents/LinkProvider/LinkProvider';
import ReturnProductCard from './ReturnProductCard';
import { setToastMessage } from '../../../../actionCreators/common';
import getSetCookie from '../../../../cookie';
import { getOrder } from '../../../../actionCreators/order';
import { submitPowers } from '../../../../actionCreators/success';
import * as cartCallsActionCreators from '../../../../actionCreators/cart';
import {
  getReturnDetails,
  cancelReturnItem,
  getRefundEstimate,
  setReturnItemDetails,
  setNewExchangeFLow,
} from '../../../../actionCreators/returnExchange';
// import Timeline from '../../../../mobile/components/MyAccount/Timeline';
import TimelineExchange from '../../../../mobile/components/MyAccount/TimelineExchange';
import {
  roundUptoDigits,
  disableBackgroundScroll,
  enableBackgroundScroll,
  removeDomainName,
  deleteExchangeStorageData,
} from '../../../../utils/helper';
import ReturnExchangeSuccessCard from './ReturnExchangeSuccessCard';
import RefundAmountBreakup from './RefundAmountBreakup';
import RefundDetails from './RefundDetails';
import CancelReturnPopup from './CancelReturnPopup';
import PowerFailModal from './powerFailModal';
import './ReturnDetails.scss';
import ReturnAddress from './ReturnAddress';

// getReturnDetails(orderId, itemId);
const allowedReturnMethods = ['warehouse_return', 'schedule_pickup', 'store_return'];
function ReturnDetails(props) {
  const {
    isExchangeFlowSet,
    setToastMessage,
    exchangeOrderId,
    loading,
    match,
    returnCancelStatus,
    returnCancelLoading,
    setReturnItemDetails,
    setNewExchangeFLow,
    getRefundEstimate,
    exchangeItemId,
    returnConfig,
    dataLocale,
    redisCommonData,
    refundEstimateData,
    cancelReturnItem,
    history,
    location,
    dataLocale: {
      PICKUP_ADDRESS,
      ORDER_DETAILS,
      CREATE_EXCHANGE_ORDER,
      BACK_TO_MY_ORDERS,
      WAREHOUSE_ADDRESS,
      CONTINUE_SHOPPING,
      YOU_HAVE_SUCCESSFULLY_CANCELLED_PRODUCT_RETURN,
      SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN,
    },
    orderDetails,
    getOrder,
    itemReturnDetails,
    getReturnDetails,
    powerSubmitFail,
    cartCallsAction,
    cartData,
  } = props;
  // const { confirmReturn, negativeStatuses, enableCancelApiFlow } = returnConfig;
  const confirmReturn = returnConfig?.confirmReturn;
  const negativeStatuses = returnConfig?.negativeStatuses;
  const enableCancelApiFlow = returnConfig?.enableCancelApiFlow;
  const [returnOrderId, setReturnOrderId] = useState(
    location?.state?.orderId || match?.params?.orderId
  );
  const [returnItemId, setReturnItemId] = useState(
    location?.state?.itemId || match?.params?.itemId
  );
  const [returnTimeline, setReturnTimeLine] = useState({ data: '' });
  const [activeState, setActiveState] = useState('');
  const [isProductReceived, setIsProductReceived] = useState(false);
  const [isExchangeInitiated, setIsExchangeInitiated] = useState(null);
  const [isReturnCancelled, setIsReturnCancelled] = useState(false);
  const [oldRTOReturn, setOldRTOReturn] = useState(false);
  const [itemPickupOrReceived, setItemPickupOrReceived] = useState(false);
  const [returnMethod, setReturnMethod] = useState('');
  const [refundStatus, getRefundStatus] = useState(null);
  const [isRefundDone, setIsRefundDone] = useState(null);
  const [showCancelReturnCallDialerPopup, setShowCancelReturnCallDialerPopup] = useState(false);
  const [showRefundCallDialerPopup, setShowRefundCallDialerPopup] = useState(false);
  const [storeCreditAmount, setStoreCreditAmount] = useState(null);
  const [refundedLkCash, setRefundedLkCash] = useState(null);
  const [partialRefundedAmount, setPartialRefundedAmount] = useState(null);
  const [refundedLkCashPlus, setrefundedLkCashPlus] = useState(null);
  const [showCancelReturnPopup, setShowCancelReturnPopup] = useState(false);
  const [showPowerFailModal, setShowPowerFailModal] = useState(true);
  const [isSubmitPowerCalled, setIsSubmitPowerCalled] = useState(false);

  const redirectToReturnLabel = () => {
    history.push({
      pathname: `/customer/my/order/return-label/${
        itemReturnDetails.item && itemReturnDetails.item.groupId
      }`,
    });
  };

  const initiateExchange = () => {
    // Delete items from cart to enter in exchange flow
    if (cartData && cartData.items && cartData.items) {
      for (let i = 0; i < cartData.items.length; i++) {
        cartCallsAction.updateCartItem(cartData.items[i].id);
      }
    }
    // cartData && cartData.items && cartData.items.map(item => {
    //     cartCallsAction.updateCartItem(item.id);
    // });
    deleteExchangeStorageData();
    // ExchangeOnly case
    sessionStorageHelper.setItem('isExchangeOnlyCase', true);
    // const { exchangeOrderId = this.orderId, exchangeItemId = this.itemId, setNewExchangeFLow } = this.props;
    sessionStorageHelper.setItem('returnAction', 'exchange');
    if (!sessionStorageHelper.getItem('returnProduct')) {
      const returnProduct = {
        returnProductId: exchangeItemId,
        returnAction: 'exchange',
      };
      sessionStorageHelper.setItem('returnProduct', returnProduct);
      setReturnItemDetails(returnProduct);
    }
    setNewExchangeFLow(true);
    getSetCookie.setCookie('exchangeOrderId', exchangeOrderId, 0.25);
    getSetCookie.setCookie('exchangeItemId', exchangeItemId, 0.25);
    history.push({
      pathname: `/customer/my/order/return/${returnOrderId}/${returnItemId}`,
      state: { orderId: returnOrderId, itemId: returnItemId },
    });
    // history.push({ pathname: `/customer/my/order/return/confirm-details/${returnOrderId}/${returnItemId}`, state: { orderId: returnOrderId, itemId: returnItemId } });
    // history.push({ pathname: `/sales/my/order/refund/${exchangeOrderId}/${exchangeItemId}/mode`, state: { orderId: exchangeOrderId, itemId: exchangeItemId } });
  };

  const gotoOrder = () => {
    const { exchangeDetails } = itemReturnDetails;
    // this.triggerTracking({ eventLev: 'view exchange order detail' });
    window.location.href = `/customer/account/order-detail/${exchangeDetails.exchangeChildId}`;
  };

  const intiateRefundOrExchange = () => {
    // Delete items from cart to enter in exchange flow
    if (cartData && cartData.items && cartData.items) {
      for (let i = 0; i < cartData.items.length; i++) {
        cartCallsAction.updateCartItem(cartData.items[i].id);
      }
    }
    // cartData && cartData.items && cartData.items.map(item => {
    //     cartCallsAction.updateCartItem(item.id);
    // });
    deleteExchangeStorageData();
    // ExchangeOnly case
    sessionStorageHelper.setItem('isExchangeOnlyCase', true);
    // const { itemReturnDetails, history, exchangeOrderId = this.orderId, exchangeItemId = this.itemId } = this.props;
    if (itemReturnDetails && !itemReturnDetails.initiateRefund) return;
    history.push({
      pathname: `/customer/my/order/return/${returnOrderId}/${returnItemId}`,
      state: { orderId: returnOrderId, itemId: returnItemId },
    });
    // history.push({ pathname: `/customer/my/order/return/confirm-details/${returnOrderId}/${returnItemId}`, state: { orderId: returnOrderId, itemId: returnItemId } });
    // this.triggerDtmOnClick('INITIATE EXCHANGE OR REFUND');
    // history.push({ pathname: `/sales/my/order/return/actions/mode/${exchangeOrderId}/${exchangeItemId}`, state: { orderId: exchangeOrderId, itemId: exchangeItemId } });
  };

  const intiateRefund = () => {
    // Delete items from cart to enter in exchange flow
    if (cartData && cartData.items && cartData.items) {
      for (let i = 0; i < cartData.items.length; i++) {
        cartCallsAction.updateCartItem(cartData.items[i].id);
      }
    }
    // cartData && cartData.items && cartData.items.map(item => {
    //     cartCallsAction.updateCartItem(item.id);
    // });
    deleteExchangeStorageData();
    // ExchangeOnly case
    sessionStorageHelper.setItem('isExchangeOnlyCase', true);
    // const { history, refundEstimateData, exchangeOrderId = this.orderId, exchangeItemId = this.itemId, setReturnItemDetails } = this.props;
    const { refundAmount } = refundEstimateData;
    if (!sessionStorageHelper.getItem('returnProduct')) {
      const returnProduct = {
        returnProductId: exchangeItemId,
        returnAction: 'refund',
      };
      sessionStorageHelper.setItem('returnProduct', returnProduct);
      setReturnItemDetails(returnProduct);
    }
    if (refundAmount) {
      history.push({
        pathname: `/customer/my/order/return/${returnOrderId}/${returnItemId}`,
        state: { orderId: returnOrderId, itemId: returnItemId },
      });
      // history.push({ pathname: `/customer/my/order/return/confirm-details/${returnOrderId}/${returnItemId}`, state: { orderId: returnOrderId, itemId: returnItemId } });
      // history.push({ pathname: `/sales/my/order/refund/${exchangeOrderId}/${exchangeItemId}/mode`, state: { orderId: exchangeOrderId, itemId: exchangeItemId } });
    } else {
      let productToReturn = sessionStorageHelper.getItem('returnProduct') || {};
      productToReturn = {
        ...productToReturn,
        refundMethod: 'customer_wallet',
      };
      sessionStorageHelper.setItem('returnProduct', productToReturn);
      setReturnItemDetails(productToReturn);
      // history.push({ pathname: `/sales/my/order/refund/${exchangeOrderId}/${exchangeItemId}/confirm-details/`, state: { refundMethod: 'customer_wallet', orderId: exchangeOrderId, itemId: exchangeItemId } });
    }
  };

  const toggleCallRefundPopupState = () => {
    if (!showRefundCallDialerPopup) {
      disableBackgroundScroll();
    } else {
      enableBackgroundScroll();
    }
    setShowRefundCallDialerPopup(!showRefundCallDialerPopup);
  };

  const retryBankTransfer = () => {
    const cashFreeRefundDetail = itemReturnDetails?.refundDetails.find(
      detail => detail.refundMethod === 'cashfree' && detail.actionUrl
    );
    const redirectUrl = cashFreeRefundDetail ? cashFreeRefundDetail.actionUrl : '';
    if (redirectUrl) {
      window.location.href =
        redirectUrl?.indexOf('www.lenskart.com') > -1 ? removeDomainName(redirectUrl) : redirectUrl;
    }
  };

  const getCTAButtons = () => {
    const {
      CHOOSE_EXCHANGE_OR_REFUND,
      PROCEED_FOR_REFUND,
      CREATE_EXCHANGE_ORDER,
      NEED_REFUND_INSTEAD,
      REFUND_OPTION_NOT_AVAILABLE_THIS_PRODUCT,
      WHEN_PRODUCT_RECEIVED_BY_LENSKART,
      RECEIVE_COMMUNICATION_EXCHANGE_OR_REFUND,
      CALL_CUSTOMER_CARE,
      ENTER_BANK_DETAILS,
      VIEW_EXCHANGE_ORDER_DETAILS,
      VIEW_RETURN_LABEL_INSTRUCTIONS,
      EXCHNAGE_ORDER_ID,
      PICKUP_SCHEDULED,
      PICKUP_COMPLETED,
      SHIP_TO_LENSKART_REQUESTED,
      BANK_REFERENCE_NUMBER,
    } = dataLocale; // EXCHANGE_PRODUCTS_GET_REFUND
    const {
      refundMethodRequest,
      returnStatus,
      isRefundable,
      isExchangeable,
      refundHistories,
      orderRefundedAmount,
      amountToRefund,
      refundDetails,
      exchangeDetails,
    } = itemReturnDetails;
    const { returnSuccess, exchangeInfo, returnCancelled, refundProcessed, confirmRefund } =
      returnConfig;
    const refundAction =
      isRefundDone || (refundMethodRequest && refundMethodRequest !== 'exchange') || '';

    let status = '';
    if (refundStatus === 'refund_pending') {
      status = 'pending';
    } else if (refundStatus === 'refund_cancelled') {
      status = 'failure';
    } else if (refundStatus === 'new_refund') {
      status = 'newRefund';
    }

    let renderSuccessConfig;
    let showStoreCreditCode;
    let storeCreditCode;
    let buttonText;
    let buttonClickHandler;
    let topazButtonText;
    let topazButtonClickHandler;
    let pickupInformation = '';
    let hasMultipleRefunds = false;
    let refundMethodConfig;
    let txnObj;

    if (isReturnCancelled) {
      status = 'failure';
      renderSuccessConfig = returnCancelled;
      // returnId = itemReturnDetails.returnId;
      // buttonText = EXCHANGE_PRODUCTS_GET_REFUND;
      // buttonClickHandler = this.initiateReturn;
    } else if (refundAction) {
      hasMultipleRefunds = Boolean(
        refundHistories &&
          (refundHistories.length > 1 ||
            (refundHistories.length > 0 && (orderRefundedAmount || amountToRefund)))
      );
      // hasMultipleRefunds = refundHistories && (refundHistories.length > 1 || (refundHistories.length > 0 && orderRefundedAmount && amountToRefund));
      let latestRefundDetail = {};
      let cashFreeRefundDetail;
      let storeCreditRefundDetail;
      let bankReferenceNumber;
      if (refundDetails && refundDetails.length) {
        refundDetails.forEach(detail => {
          if (!cashFreeRefundDetail && detail.refundMethod === 'cashfree' && detail.actionUrl) {
            cashFreeRefundDetail = detail;
          }
          if (
            !storeCreditRefundDetail &&
            detail.refundMethod === 'storecredit' &&
            detail.storeCreditCode
          ) {
            storeCreditRefundDetail = detail;
          }
          if (!bankReferenceNumber && detail.bankReferenceNumber) {
            bankReferenceNumber = detail.bankReferenceNumber;
          }
        });
        // if (isRefundDone) {
        latestRefundDetail = refundDetails[refundDetails.length - 1];
        // }
      } else if (refundMethodRequest && refundMethodRequest !== 'exchange') {
        latestRefundDetail = { refundMethod: refundMethodRequest };
      }
      const { refundMethod: latestRefundMethod } = latestRefundDetail; // refundId: refundDetailRefundId,
      refundMethodConfig = refundMethodRequest
        ? confirmRefund[refundMethodRequest]
        : confirmRefund[latestRefundMethod];
      let refundSuccessConfig;
      if (hasMultipleRefunds) {
        refundSuccessConfig = refundProcessed.multipleRefund;
        showStoreCreditCode = storeCreditAmount > 0;
        let multiRefundDesc = [...refundSuccessConfig.desc];
        if (partialRefundedAmount) {
          multiRefundDesc = multiRefundDesc.map(desc => {
            return desc.replace('<refundedAmount>', partialRefundedAmount);
          });
        }
        refundSuccessConfig.desc = multiRefundDesc;
      } else {
        refundSuccessConfig = refundProcessed[latestRefundMethod];
        showStoreCreditCode = latestRefundMethod === 'storecredit';
      }
      const { additionalInfo, creditTitle, desc } = refundSuccessConfig || {};
      renderSuccessConfig =
        refundSuccessConfig && status
          ? { additionalInfo, creditTitle, desc, ...refundSuccessConfig[status] }
          : refundSuccessConfig;
      if (showStoreCreditCode) {
        storeCreditCode =
          storeCreditRefundDetail?.storeCreditCode || itemReturnDetails.storeCreditCode;
      }
      if (status === 'pending' && cashFreeRefundDetail) {
        buttonText = ENTER_BANK_DETAILS || 'ENTER BANK DETAILS';
        buttonClickHandler = retryBankTransfer;
      } else if (
        ['cashfree', 'neft'].includes(latestRefundMethod) &&
        ['pending', 'failure'].includes(status)
      ) {
        buttonText = CALL_CUSTOMER_CARE;
        buttonClickHandler = toggleCallRefundPopupState;
        renderSuccessConfig.desc = [];
      }
      if (bankReferenceNumber) {
        txnObj = {
          txnText: BANK_REFERENCE_NUMBER || 'Bank Reference Number',
          txnId: bankReferenceNumber,
        };
      }
      // refundId = refundDetailRefundId;
    } else if (isExchangeInitiated) {
      renderSuccessConfig = exchangeInfo;
      if (['new_reverse_pickup', 'reference_id_issued'].includes(returnStatus)) {
        status = 'inExchange';
      }
      buttonText = VIEW_EXCHANGE_ORDER_DETAILS || 'VIEW EXCHANGE ORDER DETAILS';
      buttonClickHandler = gotoOrder;
      txnObj = {
        txnText: EXCHNAGE_ORDER_ID || 'Exchange Order Id',
        txnId: exchangeDetails?.exchangeChildId,
      };
    } else {
      const refundSuccessConfig = (returnSuccess && returnSuccess[returnMethod]) || {};
      const refundDesc = refundSuccessConfig?.desc?.length ? [...refundSuccessConfig.desc] : [];
      status = 'newRefund';
      if (refundMethodRequest && refundMethodRequest !== 'exchange') {
        buttonText = null;
        buttonClickHandler = null;
      } else if (isRefundable && isExchangeable) {
        buttonText = CHOOSE_EXCHANGE_OR_REFUND;
        buttonClickHandler = intiateRefundOrExchange;
      } else if (isRefundable) {
        buttonText = PROCEED_FOR_REFUND;
        buttonClickHandler = intiateRefund;
      } else if (isExchangeable) {
        buttonText = CREATE_EXCHANGE_ORDER;
        buttonClickHandler = initiateExchange;
        if (
          (Object.keys(refundSuccessConfig).length > 0 && !refundMethodRequest) ||
          (refundMethodRequest && refundMethodRequest !== 'exchange')
        ) {
          if (isProductReceived || oldRTOReturn) {
            refundDesc.push(REFUND_OPTION_NOT_AVAILABLE_THIS_PRODUCT);
          } else {
            refundDesc.push(
              `<span class="text-color_grey_black fw700">${NEED_REFUND_INSTEAD}</span>`
            );
            refundDesc.push(
              `${WHEN_PRODUCT_RECEIVED_BY_LENSKART}, ${RECEIVE_COMMUNICATION_EXCHANGE_OR_REFUND}`
            );
          }
        }
      }
      // refundSuccessConfig.desc = refundDesc;
      renderSuccessConfig = { ...refundSuccessConfig, ...{ desc: refundDesc } };
    }
    if (returnMethod === 'warehouse_return' && returnStatus === 'return_expected_wh') {
      topazButtonText = VIEW_RETURN_LABEL_INSTRUCTIONS || 'VIEW RETURN LABEL & INSTRUCTIONS';
      topazButtonClickHandler = redirectToReturnLabel;
    }
    if (
      refundMethodRequest &&
      (!refundAction || (refundAction && refundStatus !== 'refund_complete'))
    ) {
      switch (returnStatus) {
        case 'new_reverse_pickup':
        case 'reference_id_issued':
          pickupInformation = PICKUP_SCHEDULED;
          break;
        case 'awb_assigned':
          pickupInformation = PICKUP_COMPLETED;
          break;
        case 'return_expected_wh':
          pickupInformation = SHIP_TO_LENSKART_REQUESTED;
          break;
        default:
          break;
      }
    }
    return {
      renderSuccessConfig,
      refundAction,
      refundMethodConfig,
      hasMultipleRefunds,
      status,
      buttonText,
      buttonClickHandler,
      topazButtonText,
      topazButtonClickHandler,
      storeCreditCode,
      pickupInformation,
      txnObj,
    };
  };

  const findReturnAndRefundStatus = () => {
    const { TRACK_EXCHANGE_ORDER, TRACK_EXCHANGE_ORDER_VIEW_DETAILS } = dataLocale; // returnConfig
    const {
      timeLineHistories,
      exchangeDetails,
      returnType,
      returnStatus,
      returnMethod,
      refundDetails,
      amountToRefund,
      refundMethodRequest,
    } = itemReturnDetails;
    const returnStatusHistory = timeLineHistories?.filter(item => item.isCompleted === true);
    const returnHistoryLength = returnStatusHistory?.length;
    const rtoReturn = ['RTO', 'Awaited_RTO'].includes(returnType);
    let isProductReceived = false;
    let itemPickupOrReceived = false;
    let isReturnCancelled = false;
    returnStatusHistory?.forEach(obj => {
      if (obj.status === 'return_received') {
        isProductReceived = true;
      }
      if (obj.status === 'awb_assigned' || obj.status === 'return_received') {
        itemPickupOrReceived = true;
      }
    });
    const isExchangeInitiated = exchangeDetails && Object.keys(exchangeDetails).length > 0;
    if (isExchangeInitiated && itemPickupOrReceived) {
      returnStatusHistory.push({
        statusLabel: TRACK_EXCHANGE_ORDER,
        subStatusLabel: TRACK_EXCHANGE_ORDER_VIEW_DETAILS,
        subStatusLink: `/customer/account/order-detail/${exchangeDetails.exchangeChildId}`,
      });
    }
    let returnStatusKey =
      returnHistoryLength && returnStatusHistory[returnHistoryLength - 1].status;
    returnStatusKey = returnStatusKey && returnStatusKey.toLowerCase();
    if (
      [
        'return_closed',
        'customer_cancelled',
        'cancelled',
        'easy_refund_given_pickup_cancelled',
        'partial_easy_refund_given_pickup_cancelled',
      ].includes(returnStatusKey)
    ) {
      isReturnCancelled = true;
    }
    if (returnMethod === 'Old_Return' || (returnStatus === 'return_reship' && rtoReturn))
      setOldRTOReturn(true);

    // Set Refund Details
    let refundStatus;
    const refundStatusArr = (refundDetails && refundDetails.map(detail => detail.status)) || [];
    if (
      refundStatusArr.length &&
      refundStatusArr.some(status =>
        [
          'refund_pending',
          'refund_cheque_created',
          'refund_cheque_sent',
          'awaiting_neft_info',
          'imps_unknown',
          'refund_pending_pg',
        ].includes(status)
      )
    ) {
      refundStatus = 'refund_pending';
    } else if (
      refundStatusArr.length &&
      refundStatusArr.every(status => ['refund_reject', 'refund_cancelled'].includes(status))
    ) {
      refundStatus = 'refund_cancelled';
    } else if (
      (refundMethodRequest && amountToRefund) ||
      (refundMethodRequest === 'customer_wallet' && refundDetails.length === 0)
    ) {
      refundStatus = 'new_refund';
    } else {
      refundStatus = 'refund_complete';
    }
    // this.setState({
    //     activeState: returnStatusHistory.length - 1, // returnSteps: returnDetailsNextStep || '',
    //     isProductReceived,
    //     isExchangeInitiated,
    //     refundStatus,
    //     returnTimeline: {
    //         data: isExchangeInitiated && itemPickupOrReceived ? [...returnStatusHistory, ...timeLineHistories.slice(returnHistoryLength)] : timeLineHistories
    //     },
    //     itemPickupOrReceived,
    //     returnMethod: this.allowedReturnMethods.includes(returnMethod) ? returnMethod : '',
    //     isReturnCancelled,
    // }, this.updateHeaderTitle);
    setActiveState(returnStatusHistory?.length - 1);
    setIsProductReceived(isProductReceived);
    setIsExchangeInitiated(isExchangeInitiated);
    getRefundStatus(refundStatus);
    setReturnTimeLine({
      data:
        isExchangeInitiated && itemPickupOrReceived
          ? [...returnStatusHistory, ...timeLineHistories.slice(returnHistoryLength)]
          : timeLineHistories,
    });
    setItemPickupOrReceived(itemPickupOrReceived);
    setReturnMethod(
      allowedReturnMethods.includes(itemReturnDetails.returnMethod)
        ? itemReturnDetails.returnMethod
        : ''
    );
    setIsReturnCancelled(isReturnCancelled);
  };

  useEffect(() => {
    isExchangeFlowSet(true);
    const returnItemIdHere = location?.state?.itemId || match?.params?.itemId;
    setReturnItemId(returnItemIdHere);
    const returnOrderIdHere = location?.state?.orderId || match?.params?.orderId;
    setReturnOrderId(returnOrderIdHere);
    getSetCookie.deleteCookie('exchangeOrderId');
    getSetCookie.deleteCookie('exchangeItemId');
    getSetCookie.deleteCookie('exchangeMethod');
    // findReturnStatus();
    if (!(refundEstimateData && refundEstimateData.refundAmount)) {
      getRefundEstimate(returnOrderIdHere, returnItemIdHere);
    }
    getReturnDetails(returnOrderIdHere, returnItemIdHere);
    return () => {
      isExchangeFlowSet(false);
    };
  }, []);

  useEffect(() => {
    if (itemReturnDetails) {
      findReturnAndRefundStatus();
    }
  }, [itemReturnDetails]);

  useEffect(() => {
    // API call to submit power for exchange product.
    // Power is already taken while creating exchange product and saved in session
    const powerReqData = sessionStorageHelper.getItem('exchangePowerDetails');
    if (
      powerReqData?.orderId &&
      powerReqData?.orderId !== orderDetails?.result?.orders?.[0]?.id &&
      !isSubmitPowerCalled &&
      orderDetails?.result?.orders?.[0]?.id &&
      orderDetails?.result?.orders?.[0]?.items?.[0].powerRequired === 'POWER_REQUIRED'
    ) {
      const orderId = orderDetails?.result?.orders?.[0]?.id;
      const itemId = orderDetails?.result?.orders?.[0]?.items?.[0]?.id;
      if (powerReqData && powerReqData.powerData && powerReqData.email) {
        props.submitPowers(itemId, powerReqData.powerData, powerReqData.email, orderId);
        setIsSubmitPowerCalled(true);
      }
    }
  }, [orderDetails]);

  useEffect(() => {
    // if (!itemReturnDetails && !loading) {
    //     getReturnDetails(returnOrderId, returnItemId);
    // }
    if (returnCancelStatus) {
      setShowCancelReturnPopup(false);
      let message;
      if (returnCancelStatus.status === 'Success') {
        window.location.reload();
        message = YOU_HAVE_SUCCESSFULLY_CANCELLED_PRODUCT_RETURN;
      } else if (returnCancelStatus.status === 'Failure' || returnCancelStatus.error) {
        message = returnCancelStatus.error?.message || SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN;
      }
      setToastMessage({ message });
    }
  }, [returnCancelStatus]);

  // useEffect(() => {
  //     if (!orderDetails) {
  //     getOrder({ orderId: returnOrderId, dontInitSession: true, isMyAcct: true });
  //     }
  // }, [orderDetails]);

  const setCurrentState = () => {
    const { itemReturnDetails, refundEstimateData } = props;
    const { item, refundHistories } = itemReturnDetails;
    if (item) {
      const { amount } = item;
      let fullGVImplicitItem;
      let isRefundDone;
      if (amount) {
        const { subTotal, discounts } = amount;
        let discount = 0;
        let discountObj;
        for (let i = 0, len = discounts.length; i < len; i++) {
          discountObj = discounts[i];
          if (['gv', 'implicit'].includes(discountObj.type)) discount += discountObj.amount;
        }
        if (discount > 0 && discount === subTotal) {
          fullGVImplicitItem = true;
        }
      }

      const {
        refundAmount = 0,
        refundAmountLkCash = 0,
        refundAmountLkCashPlus = 0,
      } = refundEstimateData;
      const totalRefundEstimate = refundAmount + refundAmountLkCash + refundAmountLkCashPlus;

      let partialRefundedAmount = 0;
      let storeCreditAmount = 0;
      let refundedLkCash = 0;
      let refundedLkCashPlus = 0;
      if (refundHistories) {
        partialRefundedAmount = refundHistories.reduce((totalRefundPrice, refund) => {
          if (refund.method === 'storecredit') {
            storeCreditAmount = Number(refund.amount);
          } else if (refund.method === 'LKCash') {
            refundedLkCash = Number(refund.amount);
          } else if (refund.method === 'LKCashPlus') {
            refundedLkCashPlus = Number(refund.amount);
          }
          totalRefundPrice += Number(refund.amount);
          return totalRefundPrice;
        }, 0);
      }

      // If total to be refunded amount is zero and it is not a fullGVImplicit discount order and there is some refunded amount
      if (!totalRefundEstimate && !fullGVImplicitItem && partialRefundedAmount) {
        isRefundDone = true;
      }

      setIsRefundDone(isRefundDone);
      setPartialRefundedAmount(roundUptoDigits(partialRefundedAmount, 0));
      setStoreCreditAmount(roundUptoDigits(storeCreditAmount, 0));
      setRefundedLkCash(roundUptoDigits(refundedLkCash, 0));
      setrefundedLkCashPlus(roundUptoDigits(refundedLkCashPlus, 0));
    }
  };

  useEffect(() => {
    if (itemReturnDetails && refundEstimateData) {
      setCurrentState();
    }
  }, [refundEstimateData, itemReturnDetails]);

  const cancelReturnPopupToggle = () => {
    if (!showCancelReturnPopup) {
      disableBackgroundScroll();
    } else {
      enableBackgroundScroll();
    }
    setShowCancelReturnPopup(!showCancelReturnPopup);
  };

  const confirmCancelReturn = () => {
    cancelReturnItem(match?.params?.orderId || exchangeOrderId, itemReturnDetails?.returnId);
    setShowCancelReturnPopup(!showCancelReturnPopup);
  };

  const toggleCancelReturnPopupState = () => {
    if (!showCancelReturnCallDialerPopup) {
      // this.triggerDtmOnClick('Cancel Return');
      disableBackgroundScroll();
    } else {
      enableBackgroundScroll();
    }
    setShowCancelReturnCallDialerPopup(!showCancelReturnCallDialerPopup);
  };

  const onNeedHelpClickHandler = () => {
    const { userInfo } = props;
    const { email, telephone, countryCode } = userInfo?.result;
    const freshBotConfig =
      redisCommonData?.FRESHBOT_CONFIG && JSON.parse(redisCommonData.FRESHBOT_CONFIG);
    const sprinklrBotConfig =
      redisCommonData?.SPRINKLR_BOT_CONFIG && JSON.parse(redisCommonData.SPRINKLR_BOT_CONFIG);
    const freshBotEnabled = freshBotConfig.enabled === 'ON';
    const sprinklrBotEnabled = sprinklrBotConfig?.desktop_enabled === 'ON';
    if (sprinklrBotEnabled) {
      const { chatBotParams } = window;
      if (chatBotParams) {
        chatBotParams.orderNo = returnOrderId || '';
        chatBotParams.emailId = email || '';
        chatBotParams.phoneNumber = telephone || '';
        chatBotParams.sessionID = getSetCookie.getCookie(`clientV1_${countryCode}`) || '';
        chatBotParams.env = process.env.BUILD_ENV === 'development' ? 'preprod' : 'prod';
        chatBotParams.apiClient = process.env.CLIENT_TYPE;
      }
      window.setTimeout(() => {
        if (chatBotParams?.phoneNumber && window && window.sprChat) {
          window.sprChat('openNewConversation', {
            conversationContext: {
              _c_6216101a55e837709d0a6190: [chatBotParams.orderNo], // order ID from each need help button
              _c_62a1a4e3d7c1ad35cd4ae0d8: ['TRUE'], // triggeredByOrderButton
            },
            initialMessages: [{ message: 'Need Help', isSentByUser: true }],
            id: chatBotParams.orderNo, // MANDATORY, order ID from each need help button
            //  autoInitiateConversation: true
          });
        } else if (window && window.sprChat) {
          window.sprChat('open');
        }
      }, 2000);
      // history.push({ pathname: `/support?o=${returnOrderId.toString()}&e=${window.btoa(email)}&m=${window.btoa(telephone.toString())}`, state: { orderId: returnOrderId, email, telephone } });
    } else if (freshBotEnabled) {
      const { chatBotParams } = window;
      if (chatBotParams) {
        chatBotParams.orderNo = returnOrderId || '';
        chatBotParams.emailId = email || '';
        chatBotParams.phoneNumber = telephone || '';
        chatBotParams.sessionID = getSetCookie.getCookie(`clientV1_${countryCode}`) || '';
        chatBotParams.env = process.env.BUILD_ENV === 'development' ? 'preprod' : 'prod';
        chatBotParams.apiClient = process.env.CLIENT_TYPE;
      }
      window.Freshbots?.reloadContext();
      window.setTimeout(() => {
        window.Freshbots?.initiateChat();
        window.Freshbots?.showWidget(true);
      }, 2000);
      // history.push({ pathname: `/support?o=${returnOrderId.toString()}&e=${window.btoa(email)}&m=${window.btoa(telephone.toString())}`, state: { orderId: returnOrderId, email, telephone } });
    } else {
      history.push('/cms-queries');
    }
  };

  const continueShoppingClick = () => {
    getSetCookie.deleteCookie('isReturnExOld');
    // console.log('isReturnExOld cookie delete');
    window.location.href = '/';
  };

  const ctaButtons = itemReturnDetails && getCTAButtons();
  let nextSteps;
  // if(ctaButtons) {
  // const { initiateRefund, isCancellable, refundMethodRequest, item, pickupAddress, storeAddress, refundDetails: fullRefundDetails, returnStatusHeading = {} } = itemReturnDetails;
  // const { renderSuccessConfig, refundAction, refundMethodConfig, hasMultipleRefunds, status, buttonText, buttonClickHandler, topa } = ctaButtons;
  // }
  const {
    refundAmount = 0,
    refundAmountLkCash = 0,
    refundAmountLkCashPlus = 0,
  } = refundEstimateData || {};
  const totalRefundEstimate = refundAmount + refundAmountLkCash + refundAmountLkCashPlus;
  let postReturnAction = '';
  if (isExchangeInitiated) {
    postReturnAction = 'exchange';
  } else if (isRefundDone) {
    postReturnAction = 'refund';
  } else if (
    itemReturnDetails?.refundMethodRequest &&
    itemReturnDetails?.refundMethodRequest !== 'exchange'
  ) {
    postReturnAction = 'newRefund';
  }
  const nextStepsConfig = returnConfig && returnConfig[`${postReturnAction}Initiated`];
  if (
    returnMethod &&
    !itemPickupOrReceived &&
    returnMethod === 'warehouse_return' &&
    nextStepsConfig &&
    nextStepsConfig[returnMethod]
  ) {
    nextSteps = nextStepsConfig[returnMethod].infoBanner;
  }
  const { CURRENT_STATUS, CANCEL_REQUEST } = dataLocale;
  // const currentItem = orderDetails && orderDetails.result.orders && orderDetails.result.orders[0].items.find(order => order.id === Number(returnItemId));
  return (
    <>
      <div>
        {powerSubmitFail && showPowerFailModal && orderDetails?.result?.orders?.[0]?.id && (
          <PowerFailModal
            dataLocale={dataLocale}
            history={history}
            orderId={orderDetails?.result?.orders?.[0]?.id}
            setShowPowerFailModal={setShowPowerFailModal}
          />
        )}
        <h3 className="margin-l5" style={{ color: '#3C3C3C', fontFamily: 'Roboto' }}>
          <LinkProvider
            className="no-decoration back-cta inline-block cursor-pointer"
            to={`/customer/account/order-detail/${returnOrderId}`}
          >
            <i aria-hidden="true" className="fa fa-angle-left fw700 fs18 margin-r15 pos-rel"></i>
            {ORDER_DETAILS}
          </LinkProvider>
        </h3>
        {
          <div className="margin-t30 display-flex">
            <div style={{ width: '70vw', marginRight: '5px' }}>
              {ctaButtons?.renderSuccessConfig && (
                <div
                  className="d-flex flex-column justify-content-center bora-8 margin-10 order-box padding-16 align-items-center margin-12"
                  style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                >
                  <ReturnExchangeSuccessCard
                    buttonClickHandler={ctaButtons?.buttonClickHandler}
                    buttonText={ctaButtons?.buttonText}
                    dataLocale={dataLocale}
                    desc={
                      itemReturnDetails?.returnStatusHeading?.subHeadings &&
                      itemReturnDetails?.returnStatusHeading?.subHeadings.length
                        ? itemReturnDetails?.returnStatusHeading?.subHeadings
                        : ctaButtons?.renderSuccessConfig?.desc
                    }
                    estimatedDate={itemReturnDetails?.returnStatusHeading?.estimatedDate}
                    getOrder={getOrder}
                    loading={loading}
                    msg={
                      itemReturnDetails?.returnStatusHeading?.heading ||
                      ctaButtons?.renderSuccessConfig?.msg
                    }
                    orderDetails={orderDetails}
                    pickupInformation={
                      itemReturnDetails?.returnStatusHeading?.heading
                        ? ''
                        : ctaButtons?.pickupInformation
                    }
                    status={ctaButtons?.status}
                    topazButtonClickHandler={ctaButtons?.topazButtonClickHandler}
                    topazButtonText={ctaButtons?.topazButtonText}
                    txnObj={ctaButtons?.txnObj}
                    onNeedHelpClickHandler={onNeedHelpClickHandler}
                  />
                </div>
              )}

              {Boolean(
                ctaButtons?.refundAction &&
                  ctaButtons?.renderSuccessConfig &&
                  refundStatus === 'refund_complete'
              ) && (
                <div className="d-flex flex-column justify-content-center bora-8 margin-10 order-box padding-16 align-items-center margin-12">
                  <RefundDetails
                    additionalInfo={ctaButtons?.renderSuccessConfig?.additionalInfo}
                    creditTitle={ctaButtons?.renderSuccessConfig?.creditTitle}
                    dataLocale={dataLocale}
                    fullRefundDetails={itemReturnDetails?.refundDetails}
                    hasMultipleRefunds={ctaButtons?.hasMultipleRefunds}
                    refundDetails={{
                      partialRefundedAmount,
                      refundedLkCash,
                      refundedLkCashPlus,
                      storeCreditAmount,
                    }}
                    storeCreditCode={ctaButtons?.storeCreditCode}
                  />
                </div>
              )}

              <div className="d-flex flex-column justify-content-center bora-8 margin-10 order-box padding-16 align-items-center margin-12">
                <div style={{ marginTop: '20px' }}>
                  <div className="display-flex justify-space-between align-items-center">
                    <div className="fw500 text-color-grey fs16">{CURRENT_STATUS}</div>
                    {itemReturnDetails?.isCancellable && enableCancelApiFlow && (
                      <div
                        className="text-color-red fs14 fw500 text-uppercase cursor-pointer"
                        onClick={cancelReturnPopupToggle}
                      >
                        {CANCEL_REQUEST}
                      </div>
                    )}
                    {itemReturnDetails?.isCancellable && !enableCancelApiFlow && (
                      <div
                        className="text-color-red fs14 fw500 text-uppercase cursor-pointer"
                        onClick={toggleCancelReturnPopupState}
                      >
                        {CANCEL_REQUEST}
                      </div>
                    )}
                  </div>
                  {returnTimeline && returnTimeline.data && returnTimeline.data.length > 0 ? (
                    <div className="margin-t40 margin-b40">
                      <TimelineExchange
                        isDesktopReturn
                        negativeStatuses={negativeStatuses}
                        position="direction-row horizontal exchange-timeline"
                        progressFields={returnTimeline}
                        step={activeState}
                      />{' '}
                    </div>
                  ) : (
                    <div> </div>
                  )}
                  {returnMethod &&
                    itemReturnDetails &&
                    (itemReturnDetails?.pickupAddress || itemReturnDetails.storeAddress) &&
                    itemReturnDetails.returnMethod === 'store_return' && (
                      <div className="d-flex flex-column justify-content-center bora-8 margin-10 order-box padding-16 align-items-center margin-12">
                        <ReturnAddress
                          callStore
                          desktopFlow
                          disableChange
                          fadeLabel
                          pickupLabel={PICKUP_ADDRESS}
                          returnMethod={returnMethod}
                          returnMethodConfig={confirmReturn && confirmReturn[returnMethod]}
                          shipLabel={WAREHOUSE_ADDRESS}
                          storeAddress={itemReturnDetails?.storeAddress}
                          userAddress={itemReturnDetails?.pickupAddress}
                        />
                      </div>
                    )}
                </div>
              </div>
              {nextSteps && redirectToReturnLabel && (
                <div className="d-flex flex-column justify-content-center bora-8 margin-10 order-box padding-16 align-items-center margin-12">
                  <TimelineExchange
                    desktop
                    className="mr-t8"
                    position="direction-column img-banner"
                    progressFields={nextSteps}
                    redirectToReturnLabel={redirectToReturnLabel}
                  />
                </div>
              )}
              {postReturnAction &&
                postReturnAction !== 'exchange' &&
                refundStatus !== 'refund_complete' && (
                  <div className="d-flex flex-column justify-content-center bora-8 margin-10 order-box padding-16 align-items-center margin-12">
                    <div className="bg-color_white">
                      <RefundAmountBreakup
                        dataLocale={dataLocale}
                        fullRefundDetails={itemReturnDetails?.refundDetails}
                        refundAmount={refundAmount}
                        refundAmountLkCash={refundAmountLkCash + refundedLkCash}
                        refundAmountLkCashPlus={refundAmountLkCashPlus + refundedLkCashPlus}
                        refundMethodDisplaytext={ctaButtons?.refundMethodConfig?.text}
                        returnConfig={returnConfig}
                        totalRefundEstimate={totalRefundEstimate + partialRefundedAmount}
                      />
                    </div>
                  </div>
                )}
              <div
                className="margin-t30 margin-10"
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Button
                  className="btn btn-outline-info text-center block bora-4 fw700 text-uppercase roboto"
                  onClick={() => history.push({ pathname: '/customer/account/' })}
                >
                  <span className="fs15 text-uppercase" style={{ color: '#00bac6' }}>
                    {BACK_TO_MY_ORDERS}
                  </span>
                </Button>
                <Button
                  className="btn btn-outline-info text-center block bora-4 fw700 text-uppercase roboto"
                  onClick={continueShoppingClick}
                >
                  <span className="fs15 text-uppercase" style={{ color: '#00bac6' }}>
                    {CONTINUE_SHOPPING}
                  </span>
                </Button>
              </div>
            </div>
            <div
              className="bora-8 order-box"
              style={{
                width: '30vw',
                height: 'fit-content',
                marginLeft: '5px',
                marginTop: '10px',
                padding: '5px',
              }}
            >
              <ReturnProductCard
                retunConfirmPage
                exchangeItem={
                  (itemReturnDetails?.refundMethodRequest === 'exchange' ||
                    itemReturnDetails?.returnStatus === 'return_exchange') &&
                  ctaButtons &&
                  ctaButtons.buttonText &&
                  ctaButtons.buttonText !== CREATE_EXCHANGE_ORDER &&
                  orderDetails?.result?.orders?.[0]?.items
                }
                item={itemReturnDetails && itemReturnDetails?.item}
                refundMethodRequest={itemReturnDetails?.refundMethodRequest}
                top="46%"
              />
            </div>
            {/* {showCancelReturnCallDialerPopup && <PhoneDialerPopup dataLocale={dataLocale} backdrop togglePopupState={toggleCancelReturnPopupState} callConfig={returnConfig?.cancelCall} icon primaryCTAText={CALL_CUSTOMER_CARE} />} */}
            {/* {showRefundCallDialerPopup && <PhoneDialerPopup dataLocale={dataLocale} togglePopupState={toggleCallRefundPopupState} callConfig={returnConfig?.refundCall} icon primaryCTAText={CALL_CUSTOMER_CARE} />} */}
            {showCancelReturnPopup && (
              <CancelReturnPopup
                backdrop
                cancelReturnPopupToggle={cancelReturnPopupToggle}
                chatWithUs={onNeedHelpClickHandler}
                confirmCancelReturn={confirmCancelReturn}
                dataLocale={dataLocale}
                isCancellable={itemReturnDetails?.isCancellable}
                returnCancelLoading={returnCancelLoading}
                showCancelReturnPopup={showCancelReturnPopup}
              />
            )}
          </div>
        }
      </div>
    </>
  );
}

const mapStateToProps = state => {
  const cartData = state.cart.cartData ? state.cart.cartData.result : null;
  return {
    cartData,
    exchangeFlowSet: state.myAccount.exchangeFlowSet,
    dataLocale: state.locale,
    returnCancelStatus: state.returnExchange.returnCancelStatus,
    orderDetails: state.order.orderDetails,
    itemReturnDetails: state.returnExchange.itemReturnDetails,
    returnConfig: state.myAccount.returnConfig,
    exchangeOrderId: state.returnExchange.exchangeOrderId,
    exchangeItemId: state.returnExchange.exchangeItemId,
    returnDetails: state.returnExchange.returnDetails,
    refundEstimateData: state.returnExchange.refundEstimateData,
    redisCommonData: state.common.redisCommonData,
    userInfo: state.common.userInfo,
    loading: state.order.loading,
    returnCancelLoading: state.returnExchange.returnCancelLoading,
    newRefundDetails: state.returnExchange.refundDetails,
    powerSubmitFail: state.success.powerSubmitFail,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    isExchangeFlowSet: data => dispatch(isExchangeFlowSet(data)),
    getOrder: data => dispatch(getOrder(data)),
    setToastMessage: data => dispatch(setToastMessage(data)),
    cancelReturnItem: (orderId, returnId) => dispatch(cancelReturnItem(orderId, returnId)),
    getReturnDetails: (orderId, itemId) => dispatch(getReturnDetails(orderId, itemId)),
    setReturnItemDetails: data => dispatch(setReturnItemDetails(data)),
    setNewExchangeFLow: flag => dispatch(setNewExchangeFLow(flag)),
    getRefundEstimate: (orderId, itemId) => dispatch(getRefundEstimate(orderId, itemId)),
    submitPowers: (id, prescription, email, orderId) =>
      dispatch(submitPowers(id, prescription, email, orderId)),
    cartCallsAction: bindActionCreators(cartCallsActionCreators, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnDetails);
